import { parseTagString } from "@/components/ContentArea/utils";
import { TagMentionAttrs } from "@/components/ContentArea/Nodes/Tag/types";

export interface ParsedTag {
  tag: TagMentionAttrs;
  start: number;
  end: number;
  raw: string;
}

export const parseTags = (content: string): ParsedTag[] => {
  const regex = /@@@tag:(.*?)@@@/g;
  const tags: ParsedTag[] = [];
  let match;

  while ((match = regex.exec(content)) !== null) {
    tags.push({
      tag: parseTagString(match[1]),
      start: match.index!,
      end: match.index! + match[0].length,
      raw: match[0],
    });
  }

  return tags;
};
